// GTA VI launch constants shared across hero, home band, account, etc.

export const GTA6_RELEASE_TS = new Date("2026-11-19T00:00:00+05:30").getTime();
export const GTA6_RELEASE_LABEL = "19 . 11 . 2026 · IST";

export const GTA6_STANDARD_ID = "a6a6a6a6-6111-4111-8111-000000000601";
export const GTA6_ULTIMATE_ID = "a6a6a6a6-6111-4111-8111-000000000602";

export const GTA6_PRODUCT_IDS = new Set([GTA6_STANDARD_ID, GTA6_ULTIMATE_ID]);

export const GTA6_EDITIONS = {
  standard: {
    id: GTA6_STANDARD_ID,
    name: "Standard Edition",
    price: 4799,
    msrp: 5999,
  },
  ultimate: {
    id: GTA6_ULTIMATE_ID,
    name: "Ultimate Edition",
    price: 6299,
    msrp: 7499,
  },
} as const;

export function isGta6CartItem(item: { id?: string; product_id?: string } | null | undefined) {
  if (!item) return false;
  const id = item.id || item.product_id;
  return !!id && GTA6_PRODUCT_IDS.has(id);
}
